import { render, staticRenderFns } from "./sku-table.vue?vue&type=template&id=3af90476&scoped=true&"
import script from "./sku-table.vue?vue&type=script&lang=js&"
export * from "./sku-table.vue?vue&type=script&lang=js&"
import style0 from "./sku-table.vue?vue&type=style&index=0&id=3af90476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af90476",
  null
  
)

export default component.exports